const Data = [
  {
    name: "Tanuja Kumari Bhuyan",
    position: "Design Head",
    imageUrl: "/images/profile.png",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;